module.exports = __webpack_public_path__ + "static/control-36ab528f8745f0f6ffec3ebf10082cd3.jpg";